import { prefersReducedMotion } from '@theme/utilities';

const ZOOM_CLOSING_CLASS = 'buy-box-v2-zoom--closing';
const ZOOM_CLOSE_TIMEOUT = 400;

/**
 * @param {Element} element
 * @returns {(HTMLElement & { open?: (index: number) => void, closeDialog?: () => void }) | null}
 */
const zoomOf = (element) => {
  const root = element.closest('buy-box-v2');
  return root?.querySelector('zoom-dialog') ?? null;
};

/**
 * Plays the closing animation, then closes the zoom dialog.
 * @param {HTMLElement & { closeDialog?: () => void }} zoom
 */
const closeZoom = (zoom) => {
  const dialog = zoom.querySelector('dialog');
  if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
  if (prefersReducedMotion()) {
    zoom.closeDialog?.();
    return;
  }
  if (dialog.classList.contains(ZOOM_CLOSING_CLASS)) return;

  dialog.classList.add(ZOOM_CLOSING_CLASS);
  const finish = () => {
    clearTimeout(fallback);
    dialog.removeEventListener('animationend', onEnd);
    dialog.classList.remove(ZOOM_CLOSING_CLASS);
    zoom.closeDialog?.();
  };
  const onEnd = (/** @type {AnimationEvent} */ event) => {
    if (event.target === dialog) finish();
  };
  const fallback = setTimeout(finish, ZOOM_CLOSE_TIMEOUT);
  dialog.addEventListener('animationend', onEnd);
};

/**
 * Buy Box V2 zoom: opens and closes the gallery zoom dialog with a plain fade instead of the
 * gallery's view transition (`open()` without an event, `closeDialog()` after the animation).
 */
window.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('buy-box-v2')) return;

    const trigger = event.target.closest('.ax-gallery__main-item[on\\:click^="/zoom/"]');
    if (trigger) {
      const zoom = zoomOf(trigger);
      if (!zoom?.open) return;
      event.stopPropagation();
      event.preventDefault();
      zoom.open(Number(trigger.getAttribute('on:click')?.split('/').pop() ?? 0));
      return;
    }

    const close = event.target.closest('.dialog-zoomed-gallery__close-button');
    const zoom = close ? zoomOf(close) : null;
    if (!close || !zoom) return;
    event.stopPropagation();
    event.preventDefault();
    closeZoom(zoom);
  },
  { capture: true }
);

window.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const dialog = event.target.closest('.dialog-zoomed-gallery__dialog');
    const zoom = dialog?.closest('buy-box-v2') ? zoomOf(dialog) : null;
    if (!zoom) return;
    event.stopPropagation();
    event.preventDefault();
    closeZoom(zoom);
  },
  { capture: true }
);
